import { frontendURL } from '../../../../helper/URLHelper';

const smart_survey = accountId => ({
  parentNav: 'smartsurvey',
  routes: [
    'smart_survey',
    'smart_model',
    'survey_complete',
  ],
  menuItems: [
    {
      icon: 'contact-card-group',
      label: 'SMART_SURVEY',
      hasSubMenu: false,
      toState: frontendURL(`accounts/${accountId}/smart_survey`),
      toStateName: 'smart_survey',
    },
    {
      icon: 'category-finder',
      label: 'SMART_MODELS',
      hasSubMenu: false,
      toState: frontendURL(`accounts/${accountId}/smart_model`),
      toStateName: 'smart_model',
    },
  ],
});

export default smart_survey;
